/* Start of Shop by Spaces Hero */
var $window = $(window);

$(function(){
    const shopBySpacesHeroSettings = {
        classes: {
            clickableLinkDotClass: 'shop-by-spaces-hero__clickable-link-dot'
        },
        selectors: {
            clickableLinkDotSelector: '.shop-by-spaces-hero__clickable-link-dot',
            clickableLinksContainerSelector: ".shop-by-spaces-hero__clickable-links-container",
            shopBySpacesHeroSelector: ".shop-by-spaces-hero"
        },
        specs: {
            dotTextDescription: 'bold 10px Quicksand, sans-serif'
        }
    }

    let newTab = true;
    const shopBySpacesHero = document.querySelector(`${shopBySpacesHeroSettings.selectors.shopBySpacesHeroSelector}:not(.shopify-section)`);
    if(shopBySpacesHero){
        newTab = shopBySpacesHero.getAttribute('data-open-links-in-new-tab') == "true";
    }

    const calcTextWidth = function(text, font) {
        const canvas = calcTextWidth.canvas || (calcTextWidth.canvas = document.createElement("canvas"));
        const context = canvas.getContext("2d");
        context.font = font;
        const metrics = context.measureText(text);
        return metrics.width;
      }

    const insertText = function(dot){
        let text = `Featured: <a href="${dot.getAttribute('data-product-url')}" ${newTab && 'target="_blank"'}>${dot.getAttribute('data-product-title')}</a>`;
        dot.innerHTML = text;
    }

    const modifyDotDimensions = function(dot, dots, status){
        dots.forEach((singleDot) => {
            singleDot.setAttribute('style', '');
            singleDot.innerHTML = '';
        });
        if(dot){
            let textWidth = 1.13 * (calcTextWidth(`Featured: ${dot.getAttribute('data-product-title')}`, shopBySpacesHeroSettings.specs.dotTextDescription));
            let percentageAcross = parseInt(dot.getAttribute('data-position-percentage-across'));
            if(status){
                let newStyling = percentageAcross > 50 ? `right: calc(${100 - percentageAcross}% - 24px); left: calc(${percentageAcross}% - ${textWidth + 16}px + 24px); width: ${textWidth + 16}px` : `width: ${textWidth + 16}px`;
                dot.setAttribute('style', newStyling);
                insertText(dot);
            
            } else {
                dot.style.width = '24px'
            }
        }
    }

    const modifyProductCard = function(dot, dots, status){
        let allProductCards = dots[0].closest('.shop-by-spaces-hero').querySelectorAll(`.shop-by-spaces-hero__clickable-link-product`);
        let allProductTriangles = dots[0].closest('.shop-by-spaces-hero').querySelectorAll(`.shop-by-spaces-hero__clickable-link-product-triangle`);
        let allDots = dots[0].closest('.shop-by-spaces-hero').querySelectorAll(`.shop-by-spaces-hero__clickable-link-dot`);
        if(dot){
            let dotIndex = dot.getAttribute('data-index');
            allProductCards = dots[0].closest('.shop-by-spaces-hero').querySelectorAll(`.shop-by-spaces-hero__clickable-link-product:not([data-index="${dotIndex}"])`);
            allProductTriangles = dots[0].closest('.shop-by-spaces-hero').querySelectorAll(`.shop-by-spaces-hero__clickable-link-product-triangle:not([data-index="${dotIndex}"])`);
            allDots = dots[0].closest('.shop-by-spaces-hero').querySelectorAll(`.shop-by-spaces-hero__clickable-link-dot:not([data-index="${dotIndex}"])`);
        }
       
        allProductCards.forEach((productCard) => {
            productCard.setAttribute('style', 'opacity: 0; pointer-events: none; visibility: visible;');
        });
        allProductTriangles.forEach((productTriangle) => {
            productTriangle.setAttribute('style', 'opacity: 0; pointer-events: none; visibility: visible;');
        });
        allDots.forEach((singleDot) => {
            singleDot.setAttribute('style', 'background-color: var(--primary-green); border-color: var(--primary-green); pointer-events: none;');
            setTimeout(() => {
                singleDot.setAttribute('style', 'background-color: var(--primary-green); border-color: var(--primary-green);');
              }, 100);
        })
        if(dot){
            if(status){
                dot.closest('.shop-by-spaces-hero__clickable-link').querySelector('.shop-by-spaces-hero__clickable-link-product-triangle').setAttribute('style', 'visibility: visible; opacity: 1;');
                dot.closest('.shop-by-spaces-hero__clickable-link').querySelector('.shop-by-spaces-hero__clickable-link-product').setAttribute('style', 'visibility: visible; opacity: 1; pointer-events: all;');
                dot.setAttribute('style', 'background-color: var(--primary-blue); border-color: var(--primary-blue);');
            } else {
                dot.closest('.shop-by-spaces-hero__clickable-link').querySelector('.shop-by-spaces-hero__clickable-link-product-triangle').setAttribute('style', 'opacity: 0; pointer-events: none; visibility: visible;');
                dot.closest('.shop-by-spaces-hero__clickable-link').querySelector('.shop-by-spaces-hero__clickable-link-product').setAttribute('style', 'opacity: 0; pointer-events: none; visibility: visible;');
                dot.setAttribute('style', 'background-color: var(--primary-green); border-color: var(--primary-green); pointer-events: none;');
                setTimeout(() => {
                    // dot.closest('.shop-by-spaces-hero__clickable-link').querySelector('.shop-by-spaces-hero__clickable-link-product-triangle').setAttribute('style', 'visibility: hidden; opacity: 0;');
                    // dot.closest('.shop-by-spaces-hero__clickable-link').querySelector('.shop-by-spaces-hero__clickable-link-product').setAttribute('style', 'visibility: hidden; opacity: 0;');
                    dot.setAttribute('style', 'background-color: var(--primary-green); border-color: var(--primary-green);');
                  }, 100);
            }
        }
    }

    const handleDotEvent = function(event, dot, dots){
        let status;
        if(event !== "click outside"){
            status = !(dot.getAttribute('data-showing') === "true");
        }
      
        dots.forEach((singleDot) => { 
            (singleDot.setAttribute('data-showing', false));
            (singleDot.setAttribute('data-transitioning', true));
            setTimeout(() => {
                (singleDot.setAttribute('data-transitioning', false));
              }, 40);
              
        });
        if(event !== "click outside"){
            dot.setAttribute('data-showing', status);
            modifyProductCard(dot, dots, status);
        } else {
            modifyProductCard(null, dots, null);
        }
    }

    const handleProductCardHover = function(event, productCard){
        let hover = event == 'mouseenter' ? true : false;
        let clickableLink = productCard.closest('.shop-by-spaces-hero__clickable-link');
        clickableLink.setAttribute('data-product-card-hover', hover)
    }

    const onClickOutside = function(e, dots, index, imageInnerContainer) {
        let isClickedOutside = true;
        if(e.target.className.includes(shopBySpacesHeroSettings.classes.clickableLinkDotClass)  || e.target.className.includes('.shop-by-spaces-hero__clickable-link-product') || e.target.closest('.shop-by-spaces-hero__clickable-link-product')){
            isClickedOutside = false
        }
        if (isClickedOutside) {
            handleDotEvent('click outside', null, dots);
            let linkUrl = imageInnerContainer.getAttribute('data-link-url');
            if(linkUrl){
                window.open(`/pages/${linkUrl}`, '_blank');
            }
        }
      };

    const initDotHoverFocusEvent = function(shopBySpacesHeroSection){
        let dots = shopBySpacesHeroSection.querySelectorAll(`${shopBySpacesHeroSettings.selectors.clickableLinkDotSelector}`);
        let imageInnerContainers = shopBySpacesHeroSection.querySelectorAll(`${shopBySpacesHeroSettings.selectors.clickableLinksContainerSelector}`)
        let linkUrl = `/pages/${imageInnerContainers[0].getAttribute('data-link-url')}`;

        if(imageInnerContainers && imageInnerContainers.length > 0){
            imageInnerContainers.forEach((imageInnerContainer, index) => {
                imageInnerContainer.addEventListener("click", function(e){
                    onClickOutside(e, dots, index, imageInnerContainer)
                });
            })
        }

        if(dots.length > 0){
            dots.forEach((dot) => {
                    dot.addEventListener('click', (e) => {
                        handleDotEvent('click', dot, dots)
                    });
            })
        }
    }

    const initShopBySpacesSlider = function(event, shopBySpacesHeroSection) {
        let params = {};
        var menu = [];
        let autoplay = false;
        let slideAmount = parseInt(shopBySpacesHeroSection.querySelector(".shop-by-spaces-hero__slider").getAttribute('data-slides'));
        if(shopBySpacesHeroSection.querySelector(".shop-by-spaces-hero__slider").getAttribute('data-autoplay') == "true"){
            autoplay = {
                delay: shopBySpacesHeroSection.querySelector(".shop-by-spaces-hero__slider").getAttribute('data-autoplay-delay') * 1000,
                disableOnInteraction: false
            }
        };
        shopBySpacesHeroSection.querySelectorAll('.swiper-slide').forEach((slide) => {
            menu.push(slide.getAttribute('data-text'));
        });
        if(event == "load"){
                params = {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    freeMode: false,
                    autoplay: autoplay,
                    direction: 'horizontal',
                    scrollbar: {
                        el: ".shop-by-spaces-hero__container .swiper-scrollbar",
                        hide: true,
                        horizontalClass: 'swiper-scrollbar-horizontal'
                      },
                      pagination: {
                        el: ".shop-by-spaces-hero__swiper-scrollbar-inner-container .swiper-pagination",
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '">' + (menu[index]) + '</span>';
                          },
                      }
                }
        }
        if(slideAmount > 1){
                var spaceBySpacesSwiper = new Swiper(`.shop-by-spaces-hero__slider`, params);
                $(window).resize($.debounce(500, function(){
                    spaceBySpacesSwiper.update();
                    spaceBySpacesSwiper.slideTo(0)
                  }));
            } else {
                shopBySpacesHeroSection.querySelector('.swiper-pagination').innerHTML = `<span class="swiper-pagination-bullet">${menu[0]}</span>`
            }
    }

    const calcHeroTextWidth = function(text, font) {
        const canvas = calcHeroTextWidth.canvas || (calcHeroTextWidth.canvas = document.createElement("canvas"));
        const context = canvas.getContext("2d");
        context.font = font;
        const metrics = context.measureText(text);
        return metrics.width;
      }

    const initHoverStyling = function(){
        let shopBySpacesStyling = document.querySelectorAll('style[shop-by-spaces-placement="true"]');
        if(shopBySpacesStyling.length > 0){
            shopBySpacesStyling.forEach((shopBySpacesStyle) => {
                shopBySpacesStyle.remove();
            })
        }
        let clickableLinkProducts = document.querySelectorAll('.shop-by-spaces-hero__clickable-link-product');
        clickableLinkProducts.forEach((clickableLinkProduct) => {
            let currentProductWidth = window.screen.width > 480 ? 300 : 250;
            if(window.screen.width > 840){currentProductWidth = 350};
            let currentFontSize = 16;
            let currentTextWidth = window.screen.width > 480 ? 160 : 110
            if(window.screen.width > 600 && window.screen.width < 841){
                currentFontSize = 18;
            } else if (window.screen.width > 840){
                currentFontSize = 20;
            }
            let textWidth = parseInt(1 + (calcHeroTextWidth(`${clickableLinkProduct.getAttribute('data-product-title')}`, `bold ${currentFontSize}px Quicksand, sans-serif`)));
        })
    }


    const initshopBySpacesHero = function(){
        let shopBySpacesHeroSections = document.querySelectorAll('.shopify-section.shop-by-spaces-hero');
        if(shopBySpacesHeroSections.length > 0){
            shopBySpacesHeroSections.forEach((shopBySpacesHeroSection => {
                let fromMetafieldSection = shopBySpacesHeroSection.querySelector('.shop-by-spaces-hero[data-from-metafield="true"]');
                let clickableLinksContainer = shopBySpacesHeroSection.querySelectorAll('.shop-by-spaces-hero__clickable-links-container');

                if(clickableLinksContainer.length > 0){
                    initDotHoverFocusEvent(shopBySpacesHeroSection);
                    initHoverStyling();
                    $(window).resize($.throttle(50, function(){
                        initHoverStyling();
                      }));
                }
                if(fromMetafieldSection){
                    initShopBySpacesSlider("load", fromMetafieldSection);
                }
            }))
        }
    }


    window.onload = initshopBySpacesHero();
});

/* End of Shop by Spaces Hero */


$(function(){

    /* Start Custom Feature Image Slider */

    const initCustomImageSliderSwiper = function(event, customFeatureImageSection) {
        if(customFeatureImageSection.querySelector(".custom-feature-image__image-swiper")){
            let autoplay = {
                delay: customFeatureImageSection.querySelector(".custom-feature-image__image-swiper").getAttribute('data-autoplay-delay'),
                disableOnInteraction: false
            }
            let params = {};
            if(event == "load"){
                params = {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    freeMode: false,
                    autoplay: autoplay,
                    effect: 'fade',
                    crossFade: true,
                    speed: 600,
                    loop: true
                }
            }
            var swiper = new Swiper(`.custom-feature-image__image-swiper`, params);
        }
    }

    const initCustomImageSlider = function(){
        let customFeatureImageSections = document.querySelectorAll('.shopify-section.custom-feature-image-section');
        if(customFeatureImageSections.length > 0){
            customFeatureImageSections.forEach((customFeatureImageSection => {
                initCustomImageSliderSwiper("load", customFeatureImageSection);
            }))
        }
    }

    /* End Custom Feature Image Slider */

    /* Start Collection Carousel Feature Image Slider */

    const initCollectionCarouselRowSlider = function(selector){
      let params = {
        slidesPerView: 1.25,
        spaceBetween: 20,
        freeMode: false,
        breakpoints: {
            600: {
              slidesPerView: 2.25,
              spaceBetween: 20
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 20
            }
          }
      }
  
      var swiper = new Swiper(`#${selector} .collection-carousel-row.page-container .collection-carousel-row__product-carousel-container`, params);
      };
    
      const initCollectionCarouselRow = function(){
        let collectionCarouselRows = document.querySelectorAll('.collection-carousel-row.page-container .collection-carousel-row__product-carousel-container')
        if(collectionCarouselRows.length > 0){
            collectionCarouselRows.forEach((collectionCarouselRow) => {
                let selector = collectionCarouselRow.closest('.shopify-section').id;
                initCollectionCarouselRowSlider(selector);
            })
        }
      }

/* End Collection Carousel Feature Image Slider */

/* Start BFCM slide in collection page animation */

    const addAnimationClass = function(){
        let sections = document.querySelectorAll('.template-collection-2023_bfcm_sale .shopify-section');
        let sectionsToSlider = [];
        if(sections.length > 0){
            sections.forEach((section) => {
                if(!section.id.includes('shogun') && section.id.includes('template')){
                    sectionsToSlider.push(section);
                } 
            })
        }
        
        if(sectionsToSlider.length > 0){
            sectionsToSlider.forEach((sectionToSlide) => {
                if(sectionToSlide.classList.contains('custom-feature-image-section') && sectionToSlide.nextSibling.classList.contains('collection-carousel-row-section')){
                    let container = document.createElement('div');
                    let nextElement = sectionToSlide.nextSibling;
                    container.classList.add('animation-element')
                    sectionToSlide.parentNode.insertBefore(container, sectionToSlide);
                    container.appendChild(sectionToSlide);
                    container.appendChild(nextElement);
                }
                else if(sectionToSlide.classList.contains('custom-feature-image-section') ){
                    sectionToSlide.querySelector('.custom-feature-image').classList.add('animation-element');
                } else if(sectionToSlide.classList.contains('collection-carousel-row-section') && !sectionToSlide.parentElement.classList.contains('animation-element')) {
                    sectionToSlide.querySelector('.collection-carousel-row__product-carousel-container').classList.add('animation-element');
                } else if (sectionToSlide.classList.contains('feature-box-new')){
                    sectionToSlide.querySelector('.c-iwt-flex-container ').classList.add('animation-element');
                } else if (sectionToSlide.classList.contains('shop-by-spaces-hero')){
                    let container = document.createElement('div');
                    let thisElement = sectionToSlide.querySelector('.shop-by-spaces-hero__container ')
                    let nextElement = sectionToSlide.querySelector('.shop-by-spaces-hero__pdp-cta-container ');
                    container.classList.add('animation-element')
                    thisElement.parentNode.insertBefore(container, thisElement);
                    container.appendChild(thisElement);
                    container.appendChild(nextElement);
                } else if (sectionToSlide.classList.contains('progress-bar-and-text')){
                    sectionToSlide.querySelector('.progress-bar-and-text__container').classList.add('animation-element');
                } else if (!sectionToSlide.parentElement.classList.contains('animation-element')){
                    sectionToSlide.classList.add('animation-element');
                }
            })
        };

    }

    const checkIfInView = function() {
        var $animation_elements = $('.animation-element');
        var window_height = $window.height();
        var window_top_position = $window.scrollTop();
        var window_bottom_position = (window_top_position + window_height);
       
        $.each($animation_elements, function() {
          var $element = $(this);
          var element_height = $element.outerHeight();
          var element_top_position = $element.offset().top;
          var element_bottom_position = (element_top_position + element_height);
       
          //check to see if this current container is within viewport
          if ((element_bottom_position >= window_top_position) &&
              (element_top_position <= window_bottom_position)) {
            $element.addClass('in-view');
          } else if (element_bottom_position < window_top_position){
            $element.addClass('in-view');
          } else {
            // $element.removeClass('in-view');
          }
        });
      }
      

    const initCollectionPageAnimation = function(){
        addAnimationClass();

        $(window).scroll($.throttle(50, function(){
        checkIfInView();
        }));

        $(window).resize($.throttle(50, function(){
        checkIfInView();
        }));

        $window.trigger('scroll');
    }

      /* End BFCM slide in collection page animation */

      /* Start Product Tile Scripts */



  /* End Product Tile Scripts */


    const initAllElements = function(){
        initCustomImageSlider();
        initCollectionCarouselRow(); 
        initCollectionPageAnimation(); 
    } 

    window.onload = initAllElements(); 
});




//don't run the country popup on the theme customizer
if (Shopify.designMode) {
}else{

//declare global variables to store the initial detected country and the initial <h3> heading country
let initialCountryText = '';
let initialHeadingCountryText = '';
let isManualTrigger = false;

function showCountryPopup(isManual = false, userCountryCode = null) {
  isManualTrigger = isManual;
  
  if (isManual) {
    document.querySelector('.geo-heading').innerHTML = 'Select your country';
    document.querySelector('.geo-desc').innerHTML = 'Select your location below so we can display the correct prices and delivery times for your shipping destination';
  } else {
    document.querySelector('.geo-heading').innerHTML = `Visiting from <span>${initialHeadingCountryText}</span>?`;
    document.querySelector('.geo-desc').innerHTML = `Based on your location, we think you may want to shop on the Branch <span>${initialCountryText}</span> site.`;
  }

  document.querySelector('div#shopify-section-custom-country-redirect').style.display = "inline-flex";
  geoDisableScroll();

  const shopCountryCode = document.body.getAttribute('data-shop-country-code');
  const selectedCountry = getCookie('selectedCountry') || userCountryCode || (shopCountryCode === 'US' ? 'US' : 'CA');
  
  updateCountrySelection(selectedCountry, shopCountryCode);

  //remove existing event listeners
  const usaFlag = document.querySelector('#geoUsa');
  const canadaFlag = document.querySelector('#geoCanada');
  const closeButton = document.querySelector('.geo-country-modal svg');
  
  usaFlag.replaceWith(usaFlag.cloneNode(true));
  canadaFlag.replaceWith(canadaFlag.cloneNode(true));
  closeButton.replaceWith(closeButton.cloneNode(true));

  //add new event listeners
  document.querySelector('#geoUsa').addEventListener('click', () => updateCountrySelection('US', shopCountryCode));
  document.querySelector('#geoCanada').addEventListener('click', () => updateCountrySelection('CA', shopCountryCode));
  document.querySelector('.geo-country-modal svg').addEventListener('click', closePopup);
}

function closePopup() {
  document.querySelector('div#shopify-section-custom-country-redirect').style.display = "none";
  geoEnableScroll();
  setCookie('geoPopupShown', 'true', 30);
}

async function getUserCountry() {
  try {
    if (getCookie('geoPopupShown') === 'true') {
      // console.log('User has already seen the popup.');
      return;
    }

    const response = await fetch(
      window.Shopify.routes.root + 'browsing_context_suggestions.json?country[enabled]=true'
    );
    const data = await response.json();

    if (data.detected_values && data.detected_values.country) {
      const userCountryCode = data.detected_values.country.handle;
      const shopCountryCode = document.body.getAttribute('data-shop-country-code');

      if (userCountryCode !== 'US' && userCountryCode !== 'CA') {
        console.log('Popup will not show. User is neither from the USA nor Canada.');
        return;
      }

      initialCountryText = userCountryCode === 'US' ? 'US' : 'Canada';
      initialHeadingCountryText = userCountryCode === 'US' ? 'the US' : initialCountryText;

      if (userCountryCode === shopCountryCode) {
        console.log('Country popup will not show, user is from the same country');
      } else {
        console.log('COUNTRY POPUP WILL SHOW');
        showCountryPopup(false, userCountryCode);
      }
    } else {
      console.warn('No country detected in the response.');
    }
  } catch (error) {
    console.error('Error fetching user country:', error);
  }
}

function updateCountrySelection(countryCode, shopCountryCode) {
  const countryText = countryCode === 'US' ? 'US' : 'Canada';
  const goToBranchBtn = document.querySelector('.geo-country-modal .btn');
  const newGoToBranchBtn = goToBranchBtn.cloneNode(true);
  goToBranchBtn.replaceWith(newGoToBranchBtn);

  document.querySelector('#geoCanada').style.opacity = countryCode === 'US' ? '0.5' : '1';
  document.querySelector('#geoUsa').style.opacity = countryCode === 'US' ? '1' : '0.5';

  if (!isManualTrigger) {
    document.querySelector('.geo-heading span').textContent = countryCode === 'US' ? 'the US' : countryText;
    document.querySelector('.geo-desc span').textContent = countryText;
  }

  if (countryCode === shopCountryCode) {
    newGoToBranchBtn.textContent = `Stay on Branch ${countryCode === 'US' ? 'USA' : countryText}`;
    newGoToBranchBtn.href = '#';
    newGoToBranchBtn.addEventListener('click', (event) => {
      event.preventDefault();
      closePopup();
    });
  } else {
    newGoToBranchBtn.textContent = `Go to Branch ${countryCode === 'US' ? 'USA' : countryText}`;
    newGoToBranchBtn.href = countryCode === 'US' ? 'https://branchfurniture.com' : 'https://branchfurniture.ca';
    newGoToBranchBtn.addEventListener('click', () => setCookie('selectedCountry', countryCode, 30));
  }

  setCookie('selectedCountry', countryCode, 30);
}

function setCookie(name, value, days) {
  const expires = new Date();
  expires.setMonth(expires.getMonth() + 1);
  document.cookie = name + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function geoDisableScroll() {
  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';
}

function geoEnableScroll() {
  document.body.style.overflow = 'auto';
  document.documentElement.style.overflow = 'auto'; 
}

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    if (event.target.closest('.utility-bar__link--image')) {
        console.log('bah')
        event.preventDefault();
        showCountryPopup(true);
    }
});
  getUserCountry();
});

}


//BFCM title and cta animation
document.addEventListener('DOMContentLoaded', () => {
  //check template
  const bodyElement = document.body;
  if (!bodyElement.classList.contains('template-collection-2024_bfcm_sale')) {
    return; // Exit if class is not present
  }

  //select all elements to animate
  const animationGroups = document.querySelectorAll('.image-card__text-outer-container');
  if (!animationGroups.length) return;
  
  const firstContainer = animationGroups[0];
  const firstParentSection = firstContainer.closest('.collection-four-products-and-image-card');
  const firstHeader = firstContainer.querySelector('.image-card__header');
  const firstCTA = firstContainer.querySelector('.image-cta-container');
  
  //animate elements
  const animateElements = (header, cta) => {
    header.style.transition = 'opacity 1000ms ease-in-out';
    cta.style.transition = 'opacity 1000ms ease-in-out';
    
    header.style.opacity = '1';
    setTimeout(() => {
      cta.style.opacity = '1';
    }, 200);
  };
  
  //watch for attribute changes from skeleton loader
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && 
          mutation.attributeName === 'data-transitioning' &&
          firstParentSection.getAttribute('data-transitioning') === 'false') {
        // Wait 1000ms after transitioning is false, then animate
        setTimeout(() => {
          animateElements(firstHeader, firstCTA);
        }, 1000);
        observer.disconnect();
      }
    });
  });
  
  //observe the parent section for attr changes
  observer.observe(firstParentSection, {
    attributes: true,
    attributeFilter: ['data-transitioning']
  });
  
  //intersection observer for remaining elements
  const scrollObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const container = entry.target;
      //skip the first container
      if (container === firstContainer) return;
      
      const header = container.querySelector('.image-card__header');
      const ctaContainer = container.querySelector('.image-cta-container');
      
      if (entry.isIntersecting) {
        animateElements(header, ctaContainer);
        scrollObserver.unobserve(container);
      }
    });
  }, {
    threshold: 0.5, //trigger when 50% of the element is visible on the viewport
    rootMargin: '0px'
  });
  
  //observe all containers except the first one
  animationGroups.forEach((container, index) => {
    if (index !== 0) { //skip the first container
      scrollObserver.observe(container);
    }
  });
});
